// extracted by css-extract-rspack-plugin
export default {"container":"_a937a917","overlayLink":"_b9bd96aa","overlayLinkSqueeze":"_2aa105c2","image":"_7e6e3eb7","imageWrapper":"_7feb6944"};